import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons'
import BAPLIE_SYNC_STATUSES from 'constants/baplieSyncStatuses'

const getDeviceSyncStatusIcon = syncStatus => {
  switch (syncStatus) {
    case BAPLIE_SYNC_STATUSES.COMPLETED:
      return CheckCircleOutlined
    case BAPLIE_SYNC_STATUSES.PENDING:
      return SyncOutlined
    case BAPLIE_SYNC_STATUSES.SKIPPED:
    case BAPLIE_SYNC_STATUSES.SKIPPED_PORT_CALL_CLOSED:
      return MinusCircleOutlined
    case BAPLIE_SYNC_STATUSES.PARSER_FAILED:
      return CloseCircleOutlined
    default:
      return null
  }
}

export default getDeviceSyncStatusIcon
